import React, { FC } from 'react';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { getResponsiveStyle } from '@utils/responsive';
import { Breakpoint } from '@types';

type SpaceBreakpoints = {
    space: 15 | 30 | 50 | 100;
};

export interface SpaceProps {
    orientation?: 'vertical' | 'horizontal';
    backgroundColor?: Partial<Record<Breakpoint, string>>;
    // styles apply from breakpoint up
    spaceBreakpoints: {
        xs?: SpaceBreakpoints;
        sm?: SpaceBreakpoints;
        md?: SpaceBreakpoints;
        lg?: SpaceBreakpoints;
        xl?: SpaceBreakpoints;
        xxl?: SpaceBreakpoints;
    };
}

export const Space: FC<SpaceProps> = ({ orientation, backgroundColor, spaceBreakpoints }) => {
    const pageSize = useMediaQuery();

    const space = getResponsiveStyle('space', pageSize, spaceBreakpoints);
    const bgColor = backgroundColor?.[pageSize];

    return <div style={orientation === 'horizontal' ? { width: `${space}px`, backgroundColor: bgColor } : { height: `${space}px`, backgroundColor: bgColor }} />;
};
